import axios from "axios";
import { API_URL } from "../../constants";

export default {
  login: (data) => {
    return axios.post(API_URL.LOGIN, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  logoutUser: (data) => {
    return axios.post(API_URL.LOGOUT, data, {
      headers: { "Content-Type": "application/json" },
      // withCredentials: true,
    });
  },
  changePassword: (data) => {
    return axios.post(API_URL.CHANGE_PASSWORD, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  forgotVerifyPassword: (data) => {
    return axios.post(API_URL.SET_VERIFY, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  forgotVerify: (data) => {
    return axios.post(API_URL.FORGOT_PASSWORD_VERIFY, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  forgotPassword: (data) => {
    return axios.post(API_URL.FORGOT_PASSWORD, data, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  refreshToken: () => {
    return axios.post(
      API_URL.REFRESH_TOKEN,
      {},
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );
  },
};
